import React from "react";

type Props = {
    /** Two-letter country code, e.g. 'NL' */
    code: string
    size?: number
}

/**
 * Small country flag; the same image source the country filter has used before.
 */
export const CountryFlag: React.FC<Props> = ({code, size = 20}) => {
    const c = code.toLowerCase();
    if (!/^[a-z]{2}$/.test(c)) return null;
    return <img
        crossOrigin="anonymous"
        loading="lazy"
        width={size}
        srcSet={`https://flagcdn.com/w40/${c}.png 2x`}
        src={`https://flagcdn.com/w20/${c}.png`}
        alt={code.toUpperCase()}
        title={code.toUpperCase()}
        style={{verticalAlign: 'middle', borderRadius: 2}}
    />;
}
